import { form, primaryColor, setPhone } from '../../utils/variables';
import { loadPhoneComponent } from '../../views/pages/instantQuote';
import { countryCodeListeners } from '../events/countryCodeListeners';
import { phoneListeners } from '../events/phoneListeners';

export function removePhone() {
    setPhone('');
    const phone = document.querySelector('#phone');
    if (phone) {
        phone.value = '';
        document
            .querySelector('.phoneContinue__btn')
            .classList.add('disabled');
    }
}

export function newPhoneUI() {
    let tempUIStr = `
                    <div class="card">
                        <div class="icon">
                            <div class="icon__background" style="background: ${primaryColor}0f;">
                                <i data-feather="calendar"></i>
                            </div>
                        </div>
                        <div class="phone--title-wrapper">
                            <div class="phone--title">Book Appointment</div>
                            <div class="phone--sub-title">
                               Enter your phone number to book an appointment
                            </div>
                        </div>
                        <div class="phone__input-wrapper">
                            <div class="phone__input-label">Phone number</div>
                        </div>
                        <div class="phone--element">
                            <span class="phone__valid hidden">
                                <i class="ri-check-line"></i>
                            </span>
                            <span class="phone__invalid hidden">
                                <i class="ri-close-line"></i>
                            </span>
                            <div class="phone__wrapper--input">
                                <span class="phone__countryCode phone" id="phone__countryCode">
                                    <div class="phone__selected-code phone">
                                        <img class="flag-icon selected-flag">
                                        <span class="selected-country-code"></span>
                                    </div>
                                    <div class="phone__countryCode--dropdown phone hidden">
                                        <ul class="phone__countryCode--select"></ul>
                                    </div>
                                </span>
                                <input tabindex="-1" id="phone" class="phone--input" type="tel" autocomplete="tel"
                                    placeholder="Enter your phone number" inputmode="tel">
                            </div>
                        </div>
                    </div>
                    <span class="form__notice">
                        By continuing, you agree to our <u class="link" style="color: gray; cursor: pointer;">Terms</u> & <u class="link" style="color: gray; cursor: pointer;">Privacy Policy</u> and consent to receive texts. Msg & data rates may apply.
                    </span>
  `;
    let tempDom = document.querySelector('.phone__container .phone__wrappers');
    if (tempDom) {
        tempDom.innerHTML = tempUIStr;
        loadPhoneComponent();
        countryCodeListeners();
        phoneListeners();
        feather.replace();
    }

    const isWL = form?.project?.whitelabel ?? false;
    const projectWebsite = form?.project?.website;
    document.querySelectorAll('.form__notice .link').forEach((i) => {
        if (isWL) {
            if (projectWebsite) {
                i.onclick = (e) => { e.stopPropagation(); window.parent.parent.location.href = projectWebsite; };
            } else {
                i.style.cursor = 'default';
                i.style.textDecoration = 'none';
            }
        } else {
            i.onclick = (e) => {
                e.stopPropagation();
                window.parent.parent.location.href =
                    i.textContent === 'Terms'
                        ? 'https://pilotpractice.com/terms-and-conditions/'
                        : 'https://pilotpractice.com/privacy-policy/';
            };
        }
    });
}

export function oldPhoneUI() {

    let tempUIStr = `
                    <div class="phone--title-wrapper">
                        <div class="phone--title">Your phone number</div>
                    </div>
                    <div class="phone--element old-phone">
                        <span class="phone__valid hidden">
                            <i class="ri-check-line"></i>
                        </span>
                        <span class="phone__invalid hidden">
                            <i class="ri-close-line"></i>
                        </span>
                        <div class="phone__wrapper--input">
                            <span class="phone__countryCode phone" id="phone__countryCode">
                                <div class="phone__selected-code phone">
                                    <img class="flag-icon selected-flag">
                                    <span class="selected-country-code"></span>
                                </div>
                                <div class="phone__countryCode--dropdown phone hidden">
                                    <ul class="phone__countryCode--select"></ul>
                                </div>
                            </span>
                            <input tabindex="-1" id="phone" class="phone--input old-phone-input" type="tel" autocomplete="tel"
                                placeholder="Enter your phone number" inputmode="tel">
                        </div>
                    </div>
                    <span class="form__notice">
                        By continuing, you agree to our <u class="link" style="color: gray; cursor: pointer;">Terms</u> & <u class="link" style="color: gray; cursor: pointer;">Privacy Policy</u> and consent to receive texts. Msg & data rates may apply.
                    </span>
  `;
    let tempDom = document.querySelector('.phone__container .phone__wrappers');
    if (tempDom) {
        tempDom.innerHTML = tempUIStr;
        loadPhoneComponent();
        countryCodeListeners();
        phoneListeners();
    }

    const isWL = form?.project?.whitelabel ?? false;
    const projectWebsite = form?.project?.website;
    document.querySelectorAll('.form__notice .link').forEach((i) => {
        if (isWL) {
            if (projectWebsite) {
                i.onclick = (e) => { e.stopPropagation(); window.parent.parent.location.href = projectWebsite; };
            } else {
                i.style.cursor = 'default';
                i.style.textDecoration = 'none';
            }
        } else {
            i.onclick = (e) => {
                e.stopPropagation();
                window.parent.parent.location.href =
                    i.textContent === 'Terms'
                        ? 'https://pilotpractice.com/terms-and-conditions/'
                        : 'https://pilotpractice.com/privacy-policy/';
            };
        }
    });
}
